<template>
  <div class="share-configure-form mt-10">
    <div
      class="Polaris-InlineGrid"
      style="--pc-inline-grid-grid-template-columns-xs:minmax(0, 1fr);--pc-inline-grid-grid-template-columns-md:minmax(0, 2fr) minmax(0, 1fr);--pc-inline-grid-gap-xs:var(--p-space-400)"
    >
      <!-- Left column: Configuration options -->
      <div style="display:inherit;width:auto;border-inline-start:none">
        <div
          class="Polaris-InlineStack"
          style="--pc-inline-stack-align:center;--pc-inline-stack-wrap:wrap;--pc-inline-stack-gap-xs:var(--p-space-400);--pc-inline-stack-flex-direction-xs:row"
        >
          <div style="color:var(--p-color-text-info-on-bg-fill);width:100%">
            <div class="Polaris-LegacyCard">
              <div class="Polaris-LegacyCard__Section">
                <div
                  class="Polaris-LegacyStack Polaris-LegacyStack--alignmentCenter"
                >
                  <div
                    class="Polaris-LegacyStack__Item Polaris-LegacyStack__Item--fill"
                  >
                    <h2 class="Polaris-Text--root Polaris-Text--headingMd">
                      Share Widget
                    </h2>
                    <p class="mt-1 text-sm leading-5 text-gray-500">
                      Configure the WhatsApp share button to allow customers to
                      share products
                    </p>
                  </div>
                </div>
              </div>

              <!-- Position section -->
              <div class="Polaris-LegacyCard__Section">
                <div
                  class="Polaris-LegacyStack Polaris-LegacyStack--alignmentCenter"
                >
                  <div
                    class="Polaris-LegacyStack__Item Polaris-LegacyStack__Item--fill"
                  >
                    <h2 class="Polaris-Text--root Polaris-Text--headingMd">
                      Position
                    </h2>
                  </div>
                </div>

                <div class="mt-4 flex flex-wrap">
                  <div
                    class="flex items-center m-2"
                    v-for="(position, index) in supportedPosition"
                    :key="index"
                  >
                    <input
                      :id="`radio_share_${position.value}`"
                      type="radio"
                      class="form-radio h-4 w-4 text-indigo-600 transition duration-150 ease-in-out"
                      v-model="config.shareButton.position"
                      :value="position.value"
                    />
                    <label :for="`radio_share_${position.value}`" class="ml-3">
                      <span
                        class="block text-sm leading-5 font-medium text-gray-700"
                        >{{ position.label }}
                      </span>
                    </label>
                  </div>
                </div>
              </div>

              <!-- Design section -->
              <div class="Polaris-LegacyCard__Section">
                <div
                  class="Polaris-LegacyStack Polaris-LegacyStack--alignmentCenter"
                >
                  <div
                    class="Polaris-LegacyStack__Item Polaris-LegacyStack__Item--fill"
                  >
                    <h2 class="Polaris-Text--root Polaris-Text--headingMd">
                      Design
                    </h2>
                  </div>
                </div>

                <div class="mt-4 flex flex-wrap">
                  <div
                    class="flex items-center m-2"
                    v-for="(design, index) in supportedDesign"
                    :key="index"
                  >
                    <input
                      :id="`radio_share_design_${design.value}`"
                      type="radio"
                      class="form-radio h-4 w-4 text-indigo-600 transition duration-150 ease-in-out"
                      v-model="config.shareButton.design"
                      :value="design.value"
                    />
                    <label
                      :for="`radio_share_design_${design.value}`"
                      class="ml-3"
                    >
                      <span
                        class="block text-sm leading-5 font-medium text-gray-700"
                        >{{ design.label }}
                      </span>
                    </label>
                  </div>
                </div>
              </div>

              <!-- Colors section -->
              <div class="Polaris-LegacyCard__Section">
                <div
                  class="Polaris-LegacyStack Polaris-LegacyStack--alignmentCenter"
                >
                  <div
                    class="Polaris-LegacyStack__Item Polaris-LegacyStack__Item--fill"
                  >
                    <h2 class="Polaris-Text--root Polaris-Text--headingMd">
                      Colors
                    </h2>
                  </div>
                </div>

                <div
                  class="Polaris-BlockStack"
                  style="--pc-block-stack-order:column;--pc-block-stack-gap-xs:var(--p-space-400)"
                >
                  <div
                    class="Polaris-BlockStack"
                    style="--pc-block-stack-order:column;--pc-block-stack-gap-xs:var(--p-space-200)"
                    role="group"
                  >
                    <div
                      class="Polaris-InlineGrid Polaris-FormLayout--condensed"
                      style="--pc-inline-grid-grid-template-columns-xs:repeat(1, minmax(0, 1fr));--pc-inline-grid-gap-xs:var(--p-space-400)"
                    >
                      <!-- Button Background Color -->
                      <div class="Polaris-FormLayout__Item relative">
                        <div class="Polaris-Labelled__LabelWrapper">
                          <div class="Polaris-Label">
                            <label class="Polaris-Label__Text"
                              >Button Background</label
                            >
                          </div>
                        </div>
                        <div class="Polaris-Connected">
                          <div
                            class="Polaris-Connected__Item Polaris-Connected__Item--primary"
                          >
                            <div class="Polaris-TextField">
                              <input
                                class="Polaris-TextField__Input hasColor"
                                v-model="
                                  config.shareButton.colors
                                    .buttonBackgroundColor
                                "
                                type="text"
                              />
                              <verte
                                picker="square"
                                v-model="
                                  config.shareButton.colors
                                    .buttonBackgroundColor
                                "
                                class="colorPicker"
                                model="hex"
                              ></verte>
                              <div class="Polaris-TextField__Backdrop"></div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- Button Text Color -->
                      <div class="Polaris-FormLayout__Item relative">
                        <div class="Polaris-Labelled__LabelWrapper">
                          <div class="Polaris-Label">
                            <label class="Polaris-Label__Text"
                              >Button Text Color</label
                            >
                          </div>
                        </div>
                        <div class="Polaris-Connected">
                          <div
                            class="Polaris-Connected__Item Polaris-Connected__Item--primary"
                          >
                            <div class="Polaris-TextField">
                              <input
                                class="Polaris-TextField__Input hasColor"
                                v-model="
                                  config.shareButton.colors.buttonTextColor
                                "
                                type="text"
                              />
                              <verte
                                picker="square"
                                v-model="
                                  config.shareButton.colors.buttonTextColor
                                "
                                class="colorPicker"
                                model="hex"
                              ></verte>
                              <div class="Polaris-TextField__Backdrop"></div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- Button Icon Color -->
                      <div class="Polaris-FormLayout__Item relative">
                        <div class="Polaris-Labelled__LabelWrapper">
                          <div class="Polaris-Label">
                            <label class="Polaris-Label__Text"
                              >Button Icon Color</label
                            >
                          </div>
                        </div>
                        <div class="Polaris-Connected">
                          <div
                            class="Polaris-Connected__Item Polaris-Connected__Item--primary"
                          >
                            <div class="Polaris-TextField">
                              <input
                                class="Polaris-TextField__Input hasColor"
                                v-model="
                                  config.shareButton.colors.buttonIconColor
                                "
                                type="text"
                              />
                              <verte
                                picker="square"
                                v-model="
                                  config.shareButton.colors.buttonIconColor
                                "
                                class="colorPicker"
                                model="hex"
                              ></verte>
                              <div class="Polaris-TextField__Backdrop"></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Button Label -->
              <div class="Polaris-LegacyCard__Section">
                <div
                  class="Polaris-LegacyStack Polaris-LegacyStack--alignmentCenter"
                >
                  <div
                    class="Polaris-LegacyStack__Item Polaris-LegacyStack__Item--fill"
                  >
                    <h2 class="Polaris-Text--root Polaris-Text--headingMd">
                      Text
                    </h2>
                  </div>
                </div>

                <div
                  class="Polaris-BlockStack"
                  style="--pc-block-stack-order:column;--pc-block-stack-gap-xs:var(--p-space-400)"
                >
                  <div
                    class="Polaris-BlockStack"
                    style="--pc-block-stack-order:column;--pc-block-stack-gap-xs:var(--p-space-200)"
                    role="group"
                  >
                    <div
                      class="Polaris-InlineGrid Polaris-FormLayout--condensed"
                      style="--pc-inline-grid-grid-template-columns-xs:repeat(1, minmax(0, 1fr));--pc-inline-grid-gap-xs:var(--p-space-400)"
                    >
                      <div class="Polaris-FormLayout__Item">
                        <div class="Polaris-Labelled__LabelWrapper">
                          <div class="Polaris-Label">
                            <label class="Polaris-Label__Text"
                              >Button Label</label
                            >
                          </div>
                        </div>
                        <div class="Polaris-Connected">
                          <div
                            class="Polaris-Connected__Item Polaris-Connected__Item--primary"
                          >
                            <div class="Polaris-TextField">
                              <input
                                class="Polaris-TextField__Input"
                                v-model="config.shareButton.label"
                                type="text"
                              />
                              <div class="Polaris-TextField__Backdrop"></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Save Button -->
              <!-- <div class="Polaris-LegacyCard__Section">
                <div class="flex justify-end">
                  <button
                    class="Polaris-Button Polaris-Button--primary"
                    type="button"
                    @click="$emit('save')"
                  >
                    <span class="Polaris-Button__Content">
                      <span class="Polaris-Button__Text">Save</span>
                    </span>
                  </button>
                </div>
              </div> -->
            </div>
          </div>
        </div>
      </div>

      <!-- Right column: Preview -->
      <div>
        <div class="Polaris-LegacyCard">
          <div class="Polaris-LegacyCard__Section">
            <div
              class="Polaris-LegacyStack Polaris-LegacyStack--alignmentCenter"
            >
              <div
                class="Polaris-LegacyStack__Item Polaris-LegacyStack__Item--fill"
              >
                <h2 class="Polaris-Text--root Polaris-Text--headingMd">
                  Share Button Preview
                </h2>
                <div
                  class="mt-6 p-4 border rounded bg-gray-50 flex justify-center"
                >
                  <WhatsappShareButton :config="config" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Verte from "verte";
import "verte/dist/verte.css";

import WhatsappShareButton from "./WhatsappShareButton";

export default {
  name: "ShareConfigureForm",
  components: {
    Verte,
    WhatsappShareButton
  },
  model: {
    prop: "config",
    event: "change"
  },
  props: {
    config: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      phoneNumber: "",
      defaultTemplate: "",
      supportedPosition: [
        {
          label: "Left",
          value: "left"
        },
        {
          label: "Right",
          value: "right"
        }
      ],
      supportedDesign: [
        {
          label: "Button With Text and Icon",
          value: "buttonWithTextIcon"
        },
        {
          label: "Button With Icon",
          value: "buttonWithIcon"
        }
      ]
    };
  },
  mounted() {
    this.phoneNumber = this.config.phoneNumber;
  },
  methods: {
    handleSubmit(event) {
      event.preventDefault();

      console.log(this.phoneNumber);
    },
    handlePhoneNumberUpdate(phoneNumber, { number, isValid, country }) {
      console.log(number, isValid, country);
      if (isValid) {
        this.config.phoneNumber = number.e164;
      }
    },
    init() {
      this.$store.dispatch("getChatConfig");
    }
  }
};
</script>

<style lang="scss">
.colorPicker {
  position: absolute !important;
  top: 4px;
  left: 8px;
  z-index: 100;
}

/* Target the color picker when it's active/open */
.verte.colorPicker .verte__menu-origin--active {
  z-index: 10000 !important;
}

/* Also ensure the parent element has higher z-index when active */
.verte.colorPicker:has(.verte__menu-origin--active) {
  z-index: 10000 !important;
}

/* For browsers that don't support :has selector */
.Polaris-Connected__Item--primary:focus-within .verte.colorPicker,
.Polaris-Connected__Item--primary:hover .verte.colorPicker {
  z-index: 10000 !important;
}

.Polaris-TextField__Input.hasColor {
  padding-left: 42px;
}

.share-configure-form .Polaris-LegacyCard {
  overflow: visible;
}

.share-configure-form .Polaris-Connected__Item--primary {
  z-index: unset;
  position: unset;
}

.share-configure-form .Polaris-Connected__Item--primary:focus {
  z-index: 10000;
}
</style>
